




































import {Component, Prop, Vue} from 'vue-property-decorator';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';
import EquipmentTableRow from '@/components/specific/EquipmentsTable/EquipmentTableRow.vue';
import EquipmentTableSpecificRow from '@/components/specific/EquipmentsTable/EquipmentTableSpecificRow.vue';
@Component({
    components: {EquipmentTableSpecificRow, EquipmentTableRow, CSimpleTable},
})
export default class EquipmentTable extends Vue {
    @Prop() data!: any;

    @Prop({type: Boolean, default: false}) editing!: boolean;

    private visibilityArray = [];

    created() {
        this.visibilityArray = this.data.map(() => true);
    }
}
